export const VISIBILITY_INTERNAL = 'internal';
export const VISIBILITY_SEASONAL = 'seasonal';

const BOTH_VISIBILITY_TOKENS = ['both', 'all', 'everyone'];

function addUnique(list, value) {
  if (value && !list.includes(value)) list.push(value);
}

function wordsFor(value) {
  return String(value || '')
    .toLowerCase()
    .trim()
    .split(/[^a-z]+/)
    .filter(Boolean);
}

export function normalizeVisibilityTokens(value) {
  const out = [];

  const visit = (raw) => {
    if (Array.isArray(raw)) {
      raw.forEach(visit);
      return;
    }

    if (raw && typeof raw === 'object') {
      if (raw.visibilityValue !== undefined) visit(raw.visibilityValue);
      else if (raw.value !== undefined) visit(raw.value);
      else if (raw.label !== undefined) visit(raw.label);
      else if (raw.name !== undefined) visit(raw.name);
      else if (raw.title !== undefined) visit(raw.title);
      return;
    }

    const text = String(raw || '').toLowerCase().trim();
    if (!text) return;

    const words = wordsFor(text);
    const includesBoth =
      BOTH_VISIBILITY_TOKENS.some((token) => words.includes(token)) ||
      (text.indexOf(VISIBILITY_INTERNAL) !== -1 && text.indexOf(VISIBILITY_SEASONAL) !== -1);

    if (includesBoth) {
      addUnique(out, VISIBILITY_INTERNAL);
      addUnique(out, VISIBILITY_SEASONAL);
      return;
    }

    if (text.indexOf(VISIBILITY_INTERNAL) !== -1) addUnique(out, VISIBILITY_INTERNAL);
    if (text.indexOf(VISIBILITY_SEASONAL) !== -1) addUnique(out, VISIBILITY_SEASONAL);
  };

  visit(value);
  return out;
}

export function getCurrentExperience(defaultExperience = VISIBILITY_INTERNAL, preferredValue) {
  let raw = preferredValue;

  try {
    raw =
      raw ||
      window.localStorage.getItem('experience') ||
      window.localStorage.getItem('Experience') ||
      window.localStorage.getItem('siteExperience') ||
      window.localStorage.getItem('cubsExperience') ||
      window.localStorage.getItem('intranet_selected_group') ||
      defaultExperience ||
      '';
  } catch (e) {
    raw = raw || defaultExperience || '';
  }

  const tokens = normalizeVisibilityTokens(raw);
  return tokens[0] || defaultExperience || '';
}

export function visibilityTokensAllowExperience(tokens, experience, options = {}) {
  const normalizedTokens = normalizeVisibilityTokens(tokens);
  const experienceTokens = normalizeVisibilityTokens(experience || getCurrentExperience());

  if (normalizedTokens.length === 0) {
    if (options.allowEmpty) return true;
    const defaultExperience =
      options.defaultExperience === undefined ? VISIBILITY_INTERNAL : options.defaultExperience;
    if (!defaultExperience) return false;
    return experienceTokens.includes(defaultExperience);
  }

  return experienceTokens.some((token) => normalizedTokens.includes(token));
}

export function visibilityAllowsExperience(value, experience, options = {}) {
  return visibilityTokensAllowExperience(normalizeVisibilityTokens(value), experience, options);
}

export function getDepartmentVisibilityTokens(department, routeOverride = null) {
  const departments = Array.isArray(department) ? department : department ? [department] : [];
  const route = String(routeOverride || '').toLowerCase();

  if (route && departments.length === 1) {
    const deptRoute = String((departments[0] && departments[0].route) || '').toLowerCase();
    if (deptRoute && deptRoute !== route) return [];
  }

  const routeMatches = route
    ? departments.filter((dept) => String((dept && dept.route) || '').toLowerCase() === route)
    : [];
  const matchedDepartments = routeMatches.length > 0 ? routeMatches : departments;

  return normalizeVisibilityTokens(
    matchedDepartments.map((dept) => dept && dept.visibilityValue)
  );
}

export function getContentfulItemVisibilityTokens(item) {
  if (!item) return [];

  return normalizeVisibilityTokens([
    item.visibilityValue,
    getDepartmentVisibilityTokens(item.department),
  ]);
}

export function contentfulItemAllowsExperience(item, experience, options = {}) {
  return visibilityTokensAllowExperience(getContentfulItemVisibilityTokens(item), experience, options);
}
